import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import CompareBar from "./CompareBar";
import { track, Events } from "@/lib/analytics";

export default function PublicLayout() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track(Events.PAGE_VIEW, { path: loc.pathname });
  }, [loc.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <CompareBar />
    </div>
  );
}
